import React from "react";
import { LoadingButton } from "@mui/lab";
import { darken } from "@mui/system";
import { useTheme } from "@mui/material/styles";

import { IconButton, Tooltip } from "@mui/material";

export default function CustomIconButton({ children, color = "#7CA7AD", loading, disabled, ...props }) {
  const theme = useTheme();
  
  return (
    <Tooltip title={props['aria-label']}>
      <IconButton
        {...props}
        loading={loading}
        disabled={disabled}
        sx={{
          color: "#FFFFFF",
          backgroundColor: color,
          "&:hover": {
            backgroundColor: darken(color, 0.15),
            boxShadow: "none",
          },
          "&.Mui-disabled": {
            color: theme.palette.action.disabled,
            backgroundColor: theme.palette.action.disabledBackground,
          },
          borderRadius: "5px",
          ...props.sx,
        }}
      >
        {children}
      </IconButton>
    </Tooltip>
  );
}